import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import HideIcon from 'components/shared/icons/Hide'
import ShowIcon from 'components/shared/icons/Show'
import { HIDDEN_COLOR } from '../shared'

const colorBoxSize = 40

export interface ILegendItemProps {
  label: string
  bgColor?: string
  onClick?: (e: React.MouseEvent) => void
  dataLabel: string
  readOnly?: boolean
  isHidden?: boolean
  onHide?(wasHidden: boolean): void
  onCreateMorphotype?(clusterValue: string): void
  showCreateMorphotype?: boolean
  onHoverStart?(clusterValue: string): void
  onHoverEnd?(): void
  isPreFilter?: boolean
  isAlreadyAddedToFilter?: boolean
}

const LegendItem = ({
  label,
  bgColor,
  dataLabel,
  onClick,
  readOnly,
  isHidden,
  onHide,
  onCreateMorphotype,
  showCreateMorphotype,
  onHoverStart,
  onHoverEnd,
  isPreFilter,
  isAlreadyAddedToFilter,
  ...rest
}: ILegendItemProps): JSX.Element => {
  const showFilter = !readOnly

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ opacity: isHidden ? 0.4 : undefined }}
        onMouseEnter={() => onHoverStart && onHoverStart(dataLabel)}
        onMouseLeave={() => onHoverEnd && onHoverEnd()}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          {bgColor ? (
            <Box
              sx={{
                minWidth: colorBoxSize,
                minHeight: colorBoxSize,
                width: colorBoxSize,
                height: colorBoxSize,
                backgroundColor: `${isHidden || isAlreadyAddedToFilter ? HIDDEN_COLOR : bgColor} !important`,
                cursor: onClick ? 'pointer' : '',
                borderRadius: 1,
              }}
              data-testid="legend-item"
              data-label={dataLabel}
              onClick={onClick}
              {...rest}
            />
          ) : null}
          <Typography alignSelf="center">{label}</Typography>
        </Stack>
        <Stack direction="row" spacing={0.5} alignItems="center">
          {showCreateMorphotype && onCreateMorphotype && !isHidden && !isAlreadyAddedToFilter ? (
            <Tooltip title={isPreFilter ? 'Remove cells from this cluster' : 'Create morphotype from this cluster'}>
              <IconButton
                size="medium"
                onClick={() => onCreateMorphotype(dataLabel)}
                data-testid="create-morphotype-button"
                sx={{
                  color: 'primary.main',
                  '&:hover': {
                    backgroundColor: 'primary.light',
                    color: 'primary.dark',
                  }
                }}
              >
                <AddCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          ) : null}
          {showFilter ? (
            <>
              {isHidden ? (
                <ShowIcon
                  fontSize="large"
                  onClick={() => onHide && onHide(true)}
                  sx={{ cursor: 'pointer' }}
                  data-testid="visibility-toggle-icon"
                />
              ) : (
                <HideIcon
                  fontSize="large"
                  onClick={() => onHide && onHide(false)}
                  sx={{ cursor: 'pointer' }}
                  data-testid="visibility-toggle-icon"
                />
              )}
            </>
          ) : null}
        </Stack>
      </Stack>
      <Divider />
    </>
  )
}
export default LegendItem
